import React, { Fragment } from 'react';
import AgentAuthentication from './Components/Basic';

const Agent = () => (
  <Fragment>
    {/* <!-- content 시작 --> */}
    <h2 className='screen_out'>환자정보확인</h2>
    <div id='mainContent' className='doc-main' role='main'>
      <AgentAuthentication />
    </div>
    {/* <!-- content 끝 --> */}
  </Fragment>
);

export default Agent;

